/* 
Model defined for Maintaining Lead Requests. It can also be used for transferring model
*/

export class LeadRequestModel {
    name: string;
    email: string;
    mobile: string;
    comment: string;
    forexPurpose: any = ["REMMITANCE"];

    userId: string;
    branchID: string;
    products: string[];

    constructor(
        name?: string,
        email?: string,
        mobile?: string,
        comment?: string,
        forexPurpose?: any,
        userId?: string,
        branchID?: string
    ) {
        this.name = name;
        this.email = email;
        this.mobile = mobile;
        this.comment = comment;
        this.forexPurpose = ["REMMITANCE"];
        this.userId = userId;
        this.branchID = branchID;
    }
}
export class OrderRequestModel {
    consumerId: string;
    constructor(consumerId?: string) {
        this.consumerId = consumerId;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/lead/LeadRequestModel.ts